/**
 * Shared display helpers for the Evidence Provenance Layer (Iter 38).
 * Pure functions — no React.
 */

export const BATCH_STATUS_LABEL = {
  importing: "Importing",
  imported: "Imported",
  skipped_duplicate: "Duplicate (skipped)",
  failed: "Failed",
  legacy_backfill: "Legacy (unproven)",
};

// Tailwind class sets per status — kept here so the badge, the history table
// and the detail panel never drift.
export const BATCH_STATUS_CLASS = {
  importing: "bg-[var(--ml-warning)]/15 text-[#8a6d00] border-[var(--ml-warning)]/40",
  imported: "bg-[#0e6027]/10 text-[#0e6027] border-[#0e6027]/30",
  skipped_duplicate: "bg-[var(--ml-surface)] text-[var(--ml-text-secondary)] border-[var(--ml-border)]",
  failed: "bg-[var(--ml-error)]/10 text-[var(--ml-error)] border-[var(--ml-error)]/30",
  legacy_backfill: "bg-[#8a3ffc]/10 text-[#6929c4] border-[#8a3ffc]/30",
};

export function batchStatusLabel(status) {
  return BATCH_STATUS_LABEL[status] || status || "Unknown";
}

export function batchStatusClass(status) {
  return BATCH_STATUS_CLASS[status] || BATCH_STATUS_CLASS.skipped_duplicate;
}

export function fmtDateTime(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleString();
}

export function fmtDate(iso) {
  if (!iso) return "—";
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleDateString();
}

export function isLegacy(batch) {
  return batch?.status === "legacy_backfill";
}
